import React, { useState } from "react";

import "./artifacts.css";

const QUESTIONS = [
	"If this AI makes a wrong decision, is there a named person accountable, and can you detect the error within hours?",
	"Can you explain any single output to a regulator, an auditor, or the customer it affected?",
	"If the system degrades in production, do you have a tested rollback or a way to turn it off cleanly?",
];

const OPTIONS = [
	{ label: "No", score: 0 },
	{ label: "Partly", score: 1 },
	{ label: "Yes", score: 2 },
];

function verdict(score) {
	if (score >= 5) return { name: "Deploy-ready", color: "#2f855a" };
	if (score >= 3)
		return { name: "Elevated risk", color: "#dd6b20" };
	return { name: "High risk", color: "#c53030" };
}

const DeployRiskAssessment = () => {
	const [answers, setAnswers] = useState({});

	const complete = Object.keys(answers).length === QUESTIONS.length;
	const score = Object.values(answers).reduce((a, b) => a + b, 0);
	const v = verdict(score);
	const weak = QUESTIONS.filter((q, i) => answers[i] < 2);

	return (
		<div className="artifact-card">
			<div className="artifact-kicker">Interactive · Free tool</div>
			<div className="artifact-title">
				3 Questions Before You Deploy
			</div>
			<div className="artifact-intro">
				Accountability, explainability, and reversibility. If you cannot
				answer all three with a confident "Yes," the system is not ready.
			</div>

			{QUESTIONS.map((q, i) => (
				<div className="artifact-question" key={i}>
					<div className="artifact-q-text">
						{i + 1}. {q}
					</div>
					<div className="artifact-options">
						{OPTIONS.map((opt) => (
							<div
								key={opt.label}
								className={
									"artifact-option" +
									(answers[i] === opt.score
										? " selected"
										: "")
								}
								onClick={() =>
									setAnswers((prev) => ({
										...prev,
										[i]: opt.score,
									}))
								}
							>
								{opt.label}
							</div>
						))}
					</div>
				</div>
			))}

			{complete && (
				<div className="artifact-result">
					<div className="artifact-score-row">
						<span
							className="artifact-tier"
							style={{ color: v.color, fontSize: "22px" }}
						>
							{v.name}
						</span>
					</div>
					{weak.length > 0 ? (
						<div className="artifact-readout">
							Close these gaps before you ship:
							<ul className="artifact-gaps">
								{weak.map((q, i) => (
									<li key={i}>{q}</li>
								))}
							</ul>
						</div>
					) : (
						<div className="artifact-readout">
							Three clean "Yes" answers. You have the discipline
							most teams skip.
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default DeployRiskAssessment;
